export default __webpack_public_path__ + "static/media/img_23.508d4c4c.jpg";